// Dependencies
import { AxiosError } from 'axios'

// Utils
import {
  ConvertUtility as Convert
} from './convert-utility'

export class ClientUtility {
  
  /**
   * Validate response object
   * @param {*} data      - Response Object 
   * @param {String} key  - Key of Result
   * @returns {Boolean} Validate state
   */
  static has(data, key = 'result') {
    return Object.keys(data).includes(key)
  }

  /**
   * Error response handler
   * @param {String} action     - Action name
   * @param {AxiosError} error  - Request error
   * @returns {String} Error Code
   */
  static error(action, error) {

    // Validate Response
    if (!error) return

    // Error Props
    const { message, response } = error

    // Error Info
    console.warn(
      action, message, response
    )

    // Error Message
    if (!response) return message

    // Response Props
    const { data } = response

    // Response Error
    if (data) return Convert.key(data)
  }
}


// WEBPACK FOOTER //
// ./src/clients/utils/client-utility.js